<template>
  <div class="p-success-payment">
    <div class="p-success-payment_top">
      <div class="p-success-payment_top_avatars">
        <div class="p-success-payment_top_avatars_circle_outer p-success-payment_top_avatars_circle_left">
          <div class="p-success-payment_top_avatars_circle_inner">
            <span>{{ partnerInitials }}</span>
          </div>
        </div>
        <Avatar
          :userId="partnerId"
          size="52"
          class="p-success-payment_top_avatars_circle_inner p-success-payment_top_avatars_circle_right"
        />
      </div>
      <div class="p-success-payment_top_background"></div>
      <span class="p-success-payment_top_title">
        <img src="@/assets/icons/green-tick-rounded.svg" alt="ok" />
        <span class="heading-4">{{ heading }}</span>
      </span>
      <span class="p-success-payment_top_text">{{ topText }}</span>
      <span class="p-success-payment_top_text">{{ topSubtext }}</span>
    </div>
    <div class="p-success-payment_middle">
      <v-row no-gutters>
        <PaymentDetails v-if="showPaymentDetails" :price="price" :email="patient.email" :paymentDate="paymentDate" />
        <PatientDetails v-else :patient="patient" />
        <v-col cols="12" md="6" class="p-success-payment_middle_right">
          <v-row no-gutters>
            <v-col col="2">
              <img src="@/assets/icons/calendar-blue.svg" alt="calendar" />
            </v-col>
            <v-col cols="10" class="p-success-payment_middle_right_column">
              <span class="p-success-payment_middle_left_pre-text">{{ $t("visits.payment.scheduledDate") }}:</span>
              <span>{{ scheduleDate }}</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col col="2">
              <img src="@/assets/icons/time-blue.svg" alt="time" />
            </v-col>
            <v-col cols="10" class="p-success-payment_middle_right_column">
              <span class="p-success-payment_middle_left_pre-text">{{ $t("visits.payment.visitDuration") }}:</span>
              <span>{{ `${visitDurationStart} - ${visitDurationEnd}` }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <div class="p-success-payment_bottom">
      <PrimaryButton
        :fullWidth="true"
        size="large"
        :text="$t('general.buttons.done')"
        @onClick="redirectToVisitCenter"
      />
    </div>
  </div>
</template>

<script>
import { DateTime } from "luxon";
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";

import Avatar from "@/components/Avatar/Index";
import PrimaryButton from "@/components/uikit/PrimaryButton";
import { RolesEnum } from "@/types/Roles.enum";

import PatientDetails from "./PatientDetails";
import PaymentDetails from "./PaymentDetails";
export default Vue.extend({
  props: ["session"],
  name: "SuccessPaymentIndex",
  components: {
    PrimaryButton,
    Avatar,
    PatientDetails,
    PaymentDetails,
  },
  computed: {
    ...mapGetters(["role"]),
    ...mapGetters("patient", ["patient", "patientsPractitioner"]),
    ...mapGetters("slots", ["currentSlot"]),
    heading() {
      const ops = {
        [RolesEnum.Patient]: this.$t("visits.payment.complete"),
        [RolesEnum.Practitioner]: this.$t("practitioner.appointments.success.title"),
      };
      return ops[this.role] || "";
    },
    topText() {
      const practitionerName = `${this.$t("general.titles.dr")} ${this.patientsPractitioner.firstName} ${
        this.patientsPractitioner.lastName
      }`;
      const ops = {
        [RolesEnum.Patient]: this.$t("visits.payment.thanks", { name: practitionerName }),
        [RolesEnum.Practitioner]: this.$t("practitioner.appointments.success.text"),
      };
      return ops[this.role] || "";
    },
    topSubtext() {
      return this.role === RolesEnum.Practitioner ? this.$t("practitioner.appointments.success.subtext") : "";
    },
    partnerId() {
      const ops = {
        [RolesEnum.Patient]: this.patientsPractitioner && this.patientsPractitioner.id,
        [RolesEnum.Practitioner]: this.patient && this.patient.id,
      };
      return ops[this.role];
    },
    partnerInitials() {
      const ops = {
        [RolesEnum.Patient]:
          this.patientsPractitioner.firstName[0].toUpperCase() + this.patientsPractitioner.lastName[0].toUpperCase(),
        [RolesEnum.Practitioner]: this.patient.firstName[0].toUpperCase() + this.patient.lastName[0].toUpperCase(),
      };
      return ops[this.role] || "";
    },
    price() {
      return this.session ? this.session.price : 0;
    },
    paymentDate() {
      return DateTime.local().toFormat("MMMM d, yyyy");
    },
    scheduleDate() {
      if (!this.currentSlot) {
        return;
      }
      return DateTime.fromISO(this.currentSlot.start).toFormat("d/M/yyyy");
    },
    visitDurationStart() {
      if (!this.currentSlot) {
        return;
      }
      return DateTime.fromISO(this.currentSlot.start).toFormat("t");
    },
    visitDurationEnd() {
      if (!this.currentSlot) {
        return;
      }
      return DateTime.fromISO(this.currentSlot.end).toFormat("t");
    },
    showPaymentDetails() {
      return this.role === RolesEnum.Patient;
    },
  },
  methods: {
    ...mapActions("checkout", ["clearAllFields"]),
    async redirectToVisitCenter() {
      this.$emit("done");
      return this.role === RolesEnum.Patient
        ? await this.$router.push("/patient/visits/upcoming")
        : await this.$router.push("/practitioner/appointments");
    },
  },
  beforeDestroy() {
    this.clearAllFields();
  },
});
</script>

<style scoped></style>
